import { Badge, createTheme } from '@mantine/core';
import { themeToVars } from '@mantine/vanilla-extract';

export const theme = createTheme({
  fontFamily: 'Inter Variable, sans-serif',
  primaryColor: 'orange',
  spacing: {
    xxs: 'calc(0.5rem * var(--mantine-scale))',
  },
  components: {
    Badge: Badge.extend({
      vars: () => ({
        root: { '--badge-padding-x': 'var(--badge-padding-x-xs)' },
      }),
    }),
  },
  headings: {
    fontWeight: '600',

    sizes: {
      h1: {
        fontSize: '1.875rem',
        lineHeight: 'calc(2.25 / 1.875)',
      },
      h2: {
        fontSize: '1.5rem',
        lineHeight: 'calc(2 / 1.5)',
      },
      h3: {
        fontSize: '1.25rem',
        lineHeight: 'calc(1.75 / 1.25)',
      },
    },
  },
  colors: {
    foodora: [
      '#d60665',
      '#d60665',
      '#d60665',
      '#d60665',
      '#d60665',
      '#d60665',
      '#d60665',
      '#d60665',
      '#d60665',
      '#d60665',
    ],
    wolt: [
      '#58c0e4',
      '#58c0e4',
      '#58c0e4',
      '#58c0e4',
      '#58c0e4',
      '#58c0e4',
      '#58c0e4',
      '#58c0e4',
      '#58c0e4',
      '#58c0e4',
    ],
    uber_eats: [
      '#06c167',
      '#06c167',
      '#06c167',
      '#06c167',
      '#06c167',
      '#06c167',
      '#06c167',
      '#06c167',
      '#06c167',
      '#06c167',
    ],
    heapsgo: [
      '#704dff',
      '#704dff',
      '#704dff',
      '#704dff',
      '#704dff',
      '#704dff',
      '#704dff',
      '#704dff',
      '#704dff',
      '#704dff',
    ],
    huuva: [
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
    ],
    flipdish: [
      '#0b75d7',
      '#0b75d7',
      '#0b75d7',
      '#0b75d7',
      '#0b75d7',
      '#0b75d7',
      '#0b75d7',
      '#0b75d7',
      '#0b75d7',
      '#0b75d7',
    ],
  },
});

export const vars = themeToVars(theme);

export const brandTheme = createTheme({
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },
  radius: {
    small: '3px',
    regular: '6px',
    medium: '12px',
    large: '24px',
    pill: '999px',
  },
  fontFamily: "'Anonymous Pro', monospace",
  fontSizes: {
    xs: '0.8125rem',
    sm: '1rem',
    lg: '1.25rem',
    xl: '1.25rem',
    overline: '1.125rem',
  },
  headings: {
    fontWeight: '700',
    fontFamily: "'Space Grotesk Variable', sans-serif",
    sizes: {
      h1: {
        fontSize: '5.625rem',
      },
      h2: {
        fontSize: '4.375rem',
      },
      h3: {
        fontSize: '3.125rem',
      },
      h4: {
        fontSize: '2.5rem',
      },
    },
  },
  colors: {
    huuvaSunrise: [
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
      '#ff6b47',
    ],
    huuvaSky: [
      '#b0dee8',
      '#b0dee8',
      '#b0dee8',
      '#b0dee8',
      '#b0dee8',
      '#b0dee8',
      '#b0dee8',
      '#b0dee8',
      '#b0dee8',
      '#b0dee8',
    ],
    huuvaNight: [
      '#0f3b4d',
      '#0f3b4d',
      '#0f3b4d',
      '#0f3b4d',
      '#0f3b4d',
      '#0f3b4d',
      '#0f3b4d',
      '#0f3b4d',
      '#0f3b4d',
      '#0f3b4d',
    ],
    huuvaSand: [
      '#f5f0e5',
      '#f5f0e5',
      '#f5f0e5',
      '#f5f0e5',
      '#f5f0e5',
      '#f5f0e5',
      '#f5f0e5',
      '#f5f0e5',
      '#f5f0e5',
      '#f5f0e5',
    ],
    huuvaGrass: [
      '#294f3e',
      '#294f3e',
      '#294f3e',
      '#294f3e',
      '#294f3e',
      '#294f3e',
      '#294f3e',
      '#294f3e',
      '#294f3e',
      '#294f3e',
    ],
  },
});
